/*!
Segment documentation:
https://segment.com/docs/sources/website/analytics.js/#track-link

Note:
With trackLink a small timeout (300 ms) is inserted to give the track call more time.
This is useful when a page would redirect before the track method could complete all requests.
*/

import { getWindow, selectMany } from './utils/dom-utils';
import {addUTMParametersToDict} from './utils/url';

export default function initCTATracking() {
  const win = getWindow();



  win.addEventListener('load', () => {
    const ctaLinks = selectMany('.js-cta');

    ctaLinks.forEach(cta => {
      const ctaName = cta.dataset.ctaName;
      const ctaCategory = cta.dataset.ctaCategory;
      const props = cta.dataset;
      let eventName;

      if (ctaCategory) {
        eventName = 'Clicked ' + ctaCategory + ': ' + ctaName + ' CTA link';
      } else {
        eventName = 'Clicked ' + ctaName + ' CTA link';
      }

      addUTMParametersToDict(props);

      props.pageTitle = win.document.title;
      props.pageUrl = win.location.href;
      props.pagePathURL = win.location.pathname;

      analytics.trackLink(cta, eventName, props);
    });

    const ctaForms = selectMany('.js-cta-form');

    ctaForms.forEach(function (cta, i) {
      const ctaName = cta.dataset.ctaName;
      const ctaCategory = cta.dataset.ctaCategory;
      const props = cta.dataset;
      let eventName;

      if (ctaCategory) {
        eventName = 'Submitted ' + ctaCategory + ': ' + ctaName + ' CTA form';
      } else {
        eventName = 'Submitted ' + ctaName + ' CTA form';
      }

      const formContainsEmailCaptureInput = cta.querySelectorAll(":scope input[type=email]");

      if(formContainsEmailCaptureInput.length == 1) {
        // only trigger if there is just one email capture field and it's type is email
        cta.addEventListener('submit', function(){
          analytics.identify({
            email: formContainsEmailCaptureInput[0].value
          });
        });
      }

      addUTMParametersToDict(props);
      props.pageTitle = win.document.title;
      props.pageUrl = win.location.href;
      props.pagePathURL = win.location.pathname;

      
      analytics.trackForm(cta, eventName, props);
    });

  });
}
